import React from 'react'

import { useNavigate } from 'react-router-dom'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'


function Breadcrumbs({
  list = EMPTY_ARRAY, cta = null, newRoyaltyUi = false,
}) {
  const navigate = useNavigate()

  function goBack() {
    navigate(-1)
  }

  if (list.length < 1) {
    return null
  }

  return (
    <div className="container-fixed">
      <div className="breadcrumb-new__title">
        <button className="btn btn-transparent" onClick={() => goBack()}>
          <Icon type={['far', 'angle-left']} size="lg" />
        </button>
        {list[list.length - 1].title}
      </div>

      {cta && <div className="breadcrumb-new__cta">{cta}</div>}

      {!newRoyaltyUi && (
        <ul
          className="breadcrumb breadcrumb-new"
          itemType="http://schema.org/BreadcrumbList"
          itemScope
        >
          {list.map((item, i) => (
            <li
              key={item.title}
              className={`breadcrumb__item ${item.isActive ? 'is-active' : ''}`}
              itemProp="itemListElement"
              itemType="http://schema.org/ListItem"
              itemScope
            >
              {!item.isActive ? (
                <a href={item.url} itemProp="item">
                  <span itemProp="name">{item.title}</span>
                </a>
              ) : (
                <span itemProp="name">
                  {item.title}
                  <meta itemProp="item" content={item.url} />
                </span>
              )}
              <meta itemProp="position" content={i + 1} />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

Breadcrumbs.propTypes = {
  list: PropTypes.array,
  cta: PropTypes.element,
  newRoyaltyUi: PropTypes.bool,
}

export default Breadcrumbs
